import { PUBLIC_URL } from 'configs/config';
import styled from 'styled-components/macro';

const Container = styled.div`
  width: 204px;
  height: 204px;
  display: inline-block;
  overflow: hidden;
  background: none;

  .loader {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0;

    div {
      position: absolute;
      width: 100%;
      height: 100%;
      background-image: url(${`${PUBLIC_URL}/assets/img/Mapir-pin-full.gif`});
      background-repeat: no-repeat;
      background-size: contain;
      background-origin: center;
      /* top: 50%;
      left: 50%;
      transform: translate(-50%, -50%); */
    }
  }
`;

function MapirLoader({ className }: any): any {
  return (
    <Container className={[className, 'loader-wrapper'].join(' ')}>
      <div className="loader">
        <div></div>
      </div>
    </Container>
  );
}

export default MapirLoader;
